import { Information } from '@/ui/icons/linear';
import { Spacing } from '@/ui/types';
import cn from 'classnames';

import { Icon } from '../Icon';
import s from './Alert.module.css';

type AlertProps = {
  children: React.ReactNode;
  variant: 'info' | 'error';
  spacing?: Spacing;
};

const Alert = ({ children, variant, spacing }: AlertProps) => {
  return (
    <div className={cn(s.alert, s[variant], { [`spacing-${spacing}`]: !!spacing })}>
      {variant === 'info' && <Information style={{ fill: '#0F5E95', flexShrink: 0 }} size={16} />}
      {variant === 'error' && <Icon name="Alert" variant="solid" size={24} color="bloody-500" />}

      {children}
    </div>
  );
};

export default Alert;
